module.exports = __webpack_public_path__ + "img/inlinelogo.f19bae2b.png";